import {supportedSourcesForTags} from "_constants";

export function isTaggingSupported(msgSourceName) {
    return supportedSourcesForTags.includes(msgSourceName);
}

